import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NoteCreateEditComponent } from './note-create-edit.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { FuseAlertModule } from '@fleet/fuse';
import { ActionButtonsModule } from '@fleet/ui';
import { AlertsFromIssuesModule } from '@fleet/issue';
import { ProgressButtonModule } from '@fleet/shared';
import { SidebarFormLayoutModule } from '@fleet/layout';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { provideTranslocoScope, TranslocoDirective } from '@jsverse/transloco';

const lazyTranslationloader = ['en_au', 'es', 'en_us'].reduce(
  (acc: { [key: string]: () => Promise<any> }, lang) => {
    acc[lang] = () => import(`./i18n/${lang}.json`);

    return acc;
  },
  {}
);
@NgModule({
  declarations: [NoteCreateEditComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    FuseAlertModule,
    AlertsFromIssuesModule,
    ActionButtonsModule,
    ProgressButtonModule,
    MatCheckboxModule,
    SidebarFormLayoutModule,
    TranslocoDirective,
  ],
  exports: [NoteCreateEditComponent],
  providers: [
    provideTranslocoScope({
      scope: 'noteCreateEdit',
      loader: lazyTranslationloader,
    }),
  ],
})
export class NoteCreateEditModule {}
